/*---------------State Management-----------------*/
import { makeAutoObservable, runInAction } from "mobx";

/*---------------API Client-----------------------*/
import agent from "../api/agent";

/*---------------Stores---------------------------*/
import { store, Store } from "./store";

/*---------------Types & Models-------------------*/
import { Order, OrdersFilter, ReorderPayload } from "../models/Order";
import { OrderDetail } from "../models/OrderDetail";
import {
  GenerateOrderApiResponse,
  GenerateOrderPayload,
} from "../models/Order";
import { CustomerDetails } from "../models/Customer";

const { Orders } = agent;
export default class OrderStore {
  ordersList: Order[] = [];
  order: OrderDetail | null = null;
  orderId: number | null = null;
  orderLoading: boolean = false;
  orderCount: number = 0;

  constructor(private rootStore: Store) {
    makeAutoObservable(this);
  }

  setLoadingOrder = (value: boolean) => {
    this.orderLoading = value;
  };

  fetchOrders = async (filterOpts: OrdersFilter) => {
    this.setLoadingOrder(true);
    try {
      runInAction(() => {
        this.ordersList = [];
      });
      const params = new URLSearchParams();
      params.append("page", String(filterOpts.page));
      params.append("limit", String(filterOpts.limit));
      params.append("status", String(filterOpts?.status ?? ""));
      params.append("order_status", String(filterOpts?.order_status ?? ""));
      params.append(
        "order_delivery_type",
        String(filterOpts?.order_delivery_type ?? "")
      );
      params.append("startDate", String(filterOpts?.startDate ?? ""));
      params.append("endDate", String(filterOpts?.endDate ?? ""));
      params.append("outletId", String(filterOpts.outletId));
      if (store.commonStore.isDirectDelivery !== null) {
        params.append("is_direct_delivery", store.commonStore.isDirectDelivery ? "1" : "0");
      }
      const response = await Orders.list(params);
      runInAction(() => {
        this.ordersList = response.data;
        this.orderCount = response.count ?? 0;
      });
    } catch (error) {
    } finally {
      this.setLoadingOrder(false);
    }
  };

  fetchOrderCustomerStats = async (outletId: number) => {
    try {
      const response = await Orders.orderStats(outletId);
      if (response?.data && response.data.count) {
        const { count, sum } = response.data;

        const modifiedCustomer = {
          ...(this.rootStore.commonStore.customer as CustomerDetails),
          totalAmount: sum,
          totalOrders: count,
        };

        this.rootStore.commonStore.setCustomerDetail(modifiedCustomer);
      }
    } catch (error) { }
  };

  fetchOrderDetail = async (orderId: number) => {
    this.setLoadingOrder(true);
    try {
      const response = await Orders.orderDetail(orderId);
      runInAction(() => {
        this.order = response.data;
      });
      return response;
    } catch (error) {
    } finally {
      this.setLoadingOrder(false);
    }
  };

  generateOrder = async (
    payload: GenerateOrderPayload,
    headers: { customerTypeId: number; customerOrgId: number; outletId: number }
  ) => {
    this.setLoadingOrder(true);
    try {
      const modifiedPayload = {
        ...payload,
        warehouseId: store.commonStore.warehouseId ?? payload.warehouseId,
        is_direct_delivery: store.commonStore.isDirectDelivery ? 1 : 0,
      };
      const response = await Orders.generate_order(modifiedPayload, headers);
      runInAction(() => {
        this.orderId = response?.data?.order_item_result[0]?.order_id;
      });
      return response as GenerateOrderApiResponse;
    } catch (error) {
      throw error;
    } finally {
      this.setLoadingOrder(false);
    }
  };

  reorder = async (
    payload: ReorderPayload,
    headers: { customerTypeId: number; customerOrgId: number; outletId: number }
  ) => {
    try {
      const response = await Orders.reorder(payload, headers);
      return response;
    } catch (error) {
      console.log(error)
    }
  }
}
